import { ehSalaDeWhatsapp } from './janelaDoWhatsapp';

/**
 * A marca por onde o cliente chegou -- SysFar, MAX.
 *
 * O AloDesk e multi-tenant, mas SysFar e MAXSMARTPDV sao duas marcas DENTRO do
 * mesmo tenant, cada uma com o seu numero de WhatsApp e o seu menu. Sem esta
 * informacao na tela o operador se apresenta pela marca errada.
 *
 * Duas formas de payload, e a tela nao precisa saber de qual endpoint veio:
 *
 * - `/rooms`, `/rooms/{operatorId}`, `/rooms/waiting` e `/history/rooms`
 *   serializam o model inteiro, e a relacao vira a chave `whatsapp_number`
 *   (snake_case, pelo padrao do Eloquent) com `{id, rotulo, display_number}`;
 * - `/rooms/active-dashboard` monta array literal e traz `marca` direto.
 *
 * Mesma razao de existir do `ehSalaDeWhatsapp()`, que ja normaliza
 * `whatsapp_user_number` e `is_whatsapp`.
 *
 * ## A guarda: so ha marca em sala de WhatsApp
 *
 * O rotulo so e devolvido quando `ehSalaDeWhatsapp(room)` -- que ja
 * normaliza `whatsapp_user_number` (model inteiro) e `is_whatsapp === true`
 * (painel). A guarda existe para a marca nao aparecer ao lado do icone
 * errado: uma sala com numero e sem telefone do cliente desenharia o icone do
 * site COM chip de marca, um estado incoerente. Nenhum fluxo vivo produz isso
 * hoje, mas a regra nao deve depender dos dados; e no painel `is_whatsapp` e
 * `marca` chegam como campos separados, onde a incoerencia e mais facil.
 *
 * Ela mora AQUI, e nao na tela, para que a lista, o painel e o cabecalho do
 * chat herdem a mesma regra em vez de cada um derivar a sua.
 *
 * @returns {string|null} o rotulo, ou null quando nao ha marca conhecida ou a
 *          sala nao e de WhatsApp
 */
export const marcaDaSala = (room) => {
    if (!ehSalaDeWhatsapp(room)) return null;

    const rotulo = room?.whatsapp_number?.rotulo ?? room?.marca ?? null;

    if (typeof rotulo !== 'string') return null;

    // Rotulo so de espaco nao e marca. Um chip em branco na lista seria pior
    // que chip nenhum: ocupa espaco e nao diz nada.
    const limpo = rotulo.trim();

    return limpo === '' ? null : limpo;
};
